export default __webpack_public_path__ + "static/media/4-2.43095b44.png";